import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

import type { CheckboxRootEmits, CheckboxRootProps } from 'reka-ui';
    import { cn } from '@/lib/utils';
    import { Check, Minus } from 'lucide-vue-next';
    import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    defaultValue: { type: [Boolean, String] },
    modelValue: { type: [Boolean, String, null] },
    disabled: { type: Boolean },
    value: {},
    id: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    name: {},
    required: { type: Boolean },
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;
    const emits = __emit;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;
        return delegated;
    });

    const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CheckboxRoot), _mergeProps({ "data-slot": "checkbox" }, _unref(forwarded), {
    class: 
            _unref(cn)(
                'peer border-input data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=checked]:border-primary data-[state=indeterminate]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 cursor-pointer rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _createVNode(_unref(CheckboxIndicator), {
        "data-slot": "checkbox-indicator",
        class: "flex items-center justify-center text-current transition-none"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {
            state: _unref(forwarded).modelValue
          }, () => [
            (_unref(forwarded).modelValue === 'indeterminate')
              ? (_openBlock(), _createBlock(_unref(Minus), {
                  key: 0,
                  class: "size-3.5"
                }))
              : (_openBlock(), _createBlock(_unref(Check), {
                  key: 1,
                  class: "size-3.5"
                }))
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})